import { useTranslation } from "react-i18next";

const PageLoadState = ({ state, message, onRetry }) => {
  const { t } = useTranslation();

  if (state === "ready") return null;

  return (
    <div
      className={`page-load-state page-load-state--${state}`}
      role={state === "error" ? "alert" : "status"}
    >
      <p>{message}</p>
      {state === "error" && onRetry && (
        <button type="button" onClick={onRetry}>
          {t("common.retry")}
        </button>
      )}
    </div>
  );
};

export default PageLoadState;
